import SettingFrame from "../../../../components/@settings/SettingFrame";
import ViewAuditTrail from "../../../../components/@audit/ViewAuditTrail";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function AuditTrailViewPage() {

    let routeType = routeTypes.admin

    return (
        <SettingFrame
            routeType={routeType}
        >
            <ViewAuditTrail
                routeType={routeType}
            />
        </SettingFrame>
    )
}       